<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
        <v-card-title class="primary--text font-weight-bold">
          <h5>{{ $t("cropMessage") }}</h5>
        </v-card-title>
        <v-card elevation="0">
          <vue-cropper
            v-if="newImage"
            ref="cropper"
            :src="newImage"
            alt="Source Image"
            :minContainerHeight="200"
          >
          </vue-cropper>
        </v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" class="font-weight-bold" text @click="cancel()">{{
            $t("no")
          }}</v-btn>
          <v-btn
            color="secondary"
            class="font-weight-bold"
            text
            @click="cropThis()"
            >{{ $t("yesApply") }}</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { b64toBlob } from "@/app/core-module/util/base64_to_blob.js";

export default {
  data() {
    return {
      image: null,
      newImage: null,
      dialog: false,
    };
  },
  components: {
    VueCropper,
  },

  created() {
    this.newImage = null;
  },
  methods: {
    show(image) {
      this.dialog = true;
      this.newImage = null;

      this.newImage = image;
    },
    cropThis() {
      let dataUrl = this.$refs.cropper
        .getCroppedCanvas()
        .toDataURL("image/jpeg", 0.9);

      let imageblob = b64toBlob(dataUrl);

      this.$emit("croppedData", imageblob, dataUrl);

      this.newImage = null;

      this.dialog = false;
    },
    cancel() {
      this.newImage = null;

      this.dialog = false;
    },
  },
};
</script>
